import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const PaywallContext = createContext(null);

// Fetch paywall status WITHOUT the authenticated api instance so we can call it
// before the admin logs in (public endpoint).
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaywallProvider({ children }) {
  const [state, setState] = useState({ loading: true, suspended: false, status: null, data: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BASE}/paywall/status`, { timeout: 8000 });
      setState({ loading: false, suspended: !!data.suspended, status: data.status, data });
    } catch (e) {
      // Fail OPEN — if the API is unreachable, we don't want to hard-suspend the whole site.
      // The server-side gates still apply when backend is up.
      console.warn("Paywall status fetch failed; failing open", e);
      setState({ loading: false, suspended: false, status: "unknown", data: null });
    }
  }, []);

  useEffect(() => {
    refresh();
    // Re-check every 5 minutes while the tab is open so suspension kicks in in near-realtime
    const id = window.setInterval(refresh, 5 * 60 * 1000);
    return () => window.clearInterval(id);
  }, [refresh]);

  return (
    <PaywallContext.Provider value={{ ...state, refresh }}>
      {children}
    </PaywallContext.Provider>
  );
}

export function usePaywall() {
  return useContext(PaywallContext) || { loading: true, suspended: false, status: null };
}
